var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1835 50.9827C1.9401 63.2235 1.93917 83.1512 14.1787 95.389C26.4154 107.627 46.3447 107.628 58.5866 95.3865L69.7701 84.2025L54.7665 69.1989L47.2804 76.6938L43.5884 80.3868C39.6086 84.3666 33.1446 84.367 29.165 80.3854C25.1869 76.4064 25.1859 69.9432 29.1648 65.9642L32.8542 62.2759L40.341 54.7734L25.3664 39.7988L21.5512 43.6141L14.1835 50.9827Z",
    stroke: "currentColor",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3337 58.6405L95.3347 58.6395M95.3877 58.5857C107.63 46.3438 107.631 26.4167 95.3908 14.1779C83.1541 1.94028 63.2256 1.93978 50.9826 14.1819L39.7891 25.377L54.7602 40.3481L65.9587 29.1558C69.9392 25.1762 76.4024 25.1813 80.3798 29.1587C84.3587 33.1376 84.3602 39.6005 80.3797 43.5799L69.1853 54.7734L87.7278 73.3168",
    stroke: "currentColor",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.7df8a7cf82a696679d23a0d743e08fe0.svg";
export { ForwardRef as ReactComponent };